export const ADMIN_PAYMENT = "admin_payment";
export const ADMIN_GOVERNMENT_PAYMENT = "admin_government_payment";
export const REGISTRY_PAYMENT = "registry_payment";
export const REQUISITES_PAYMENT = "requisites_payment";
